<template>
  <div class="evolution-tab">
    <div
      v-if="summary.series && summary.series.length > 1"
      class="box tablero-preview"
    >
      <h2 class="tablero-preview-title">Datos generales</h2>

      <div class="tira">
        <div class="tira-chips">
          <span class="tira-label">Evolución</span>
          <template v-for="(pt, i) in summary.series">
            <span v-if="i > 0" :key="`line-${i}`" class="tira-line"></span>
            <span
              :key="i"
              class="tira-chip"
              :class="{ 'is-anchor': i === activeIndex }"
              @click="selectedIndex = i"
            >
              {{ dateLabel(pt) }}
              <span v-if="i === summary.series.length - 1" class="tira-chip-tag">
                actual
              </span>
            </span>
          </template>
        </div>
        <p class="tira-hint">
          Selecciona un año del histórico para filtrar los cuadrantes generales.
        </p>
      </div>

      <div class="tablero-body">
      <div
        class="engagement-circle engagement-circle-lg"
        :class="`rango${rangos(displayedValue('engad'))}`"
      >
        <span class="engagement-label">Engagement</span>
        <span class="engagement-value">
          {{ displayedValue('engad') | number1(1) }}%
        </span>
        <sparkline
          :values="seriesValues('engad')"
          :domain-min="sparklineDomain.min"
          :domain-max="sparklineDomain.max"
          :marker-index="sparklineMarkerIndex"
          :width="46"
          :height="14"
          class="engagement-sparkline"
        />
        <variation-chip
          class="engagement-variation-chip"
          :current="displayedValue('engad')"
          :previous="displayedPrevious('engad')"
          :size="10"
        />
      </div>

      <table class="table-general">
        <tr>
          <td colspan="4" class="has-text-centered is-size-3">
            <div :class="`rango${rangos(displayedValue('CClimad'))}`">
              <div
                class="is-flex clima-total-row"
                style="justify-content: center; align-items: center;"
              >
                <div class="clima-main-flex">
                  <div class="clima-text-block">
                    <div class="clima-title-group">
                      <p class="clima-nombre-line">
                        Clima total
                        <span>{{ nombrerangos[rangos(displayedValue('CClimad'))] }}</span>
                      </p>
                      <p class="clima-valor-line">
                        {{ displayedValue('CClimad') | number1(1) }}%
                      </p>
                    </div>
                    <div class="clima-content-value">
                      <sparkline
                        :values="seriesValues('CClimad')"
                        :domain-min="sparklineDomain.min"
                        :domain-max="sparklineDomain.max"
                        :marker-index="sparklineMarkerIndex"
                        :width="70"
                        :height="24"
                        class="clima-sparkline"
                      />
                      <variation-chip
                        class="clima-variation-chip"
                        :current="displayedValue('CClimad')"
                        :previous="displayedPrevious('CClimad')"
                        :label="comparisonLabel"
                        :size="15"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="is-size-5 has-text-centered">
            <div :class="`rango${rangos(displayedValue('apoyod'))}`">
              <div
                class="is-flex tile-row"
                style="justify-content: space-between; align-items: center;"
              >
                <h1 class="tile-title">
                  Apoyo <br class="is-hidden-desktop" />
                  {{ displayedValue('apoyod') | number1(1) }}%
                </h1>
                <div class="quadrant-indicators">
                  <sparkline
                    :values="seriesValues('apoyod')"
                    :domain-min="sparklineDomain.min"
                    :domain-max="sparklineDomain.max"
                    :marker-index="sparklineMarkerIndex"
                    :width="56"
                    :height="20"
                  />
                  <variation-chip
                    :current="displayedValue('apoyod')"
                    :previous="displayedPrevious('apoyod')"
                    :label="comparisonLabel"
                  />
                </div>
              </div>
            </div>
          </td>
          <td colspan="2" class="is-size-5 has-text-centered">
            <div :class="`rango${rangos(displayedValue('innovaciond'))}`">
              <div
                class="is-flex tile-row"
                style="justify-content: space-between; align-items: center;"
              >
                <h1 class="tile-title">
                  Innovación <br class="is-hidden-desktop" />
                  {{ displayedValue('innovaciond') | number1(1) }}%
                </h1>
                <div class="quadrant-indicators">
                  <sparkline
                    :values="seriesValues('innovaciond')"
                    :domain-min="sparklineDomain.min"
                    :domain-max="sparklineDomain.max"
                    :marker-index="sparklineMarkerIndex"
                    :width="56"
                    :height="20"
                  />
                  <variation-chip
                    :current="displayedValue('innovaciond')"
                    :previous="displayedPrevious('innovaciond')"
                    :label="comparisonLabel"
                  />
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="is-size-5 has-text-centered">
            <div :class="`rango${rangos(displayedValue('calidadd'))}`">
              <div
                class="is-flex tile-row"
                style="justify-content: space-between; align-items: center;"
              >
                <h1 class="tile-title">
                  Calidad <br class="is-hidden-desktop" />
                  {{ displayedValue('calidadd') | number1(1) }}%
                </h1>
                <div class="quadrant-indicators">
                  <sparkline
                    :values="seriesValues('calidadd')"
                    :domain-min="sparklineDomain.min"
                    :domain-max="sparklineDomain.max"
                    :marker-index="sparklineMarkerIndex"
                    :width="56"
                    :height="20"
                  />
                  <variation-chip
                    :current="displayedValue('calidadd')"
                    :previous="displayedPrevious('calidadd')"
                    :label="comparisonLabel"
                  />
                </div>
              </div>
            </div>
          </td>
          <td colspan="2" class="is-size-5 has-text-centered">
            <div :class="`rango${rangos(displayedValue('metasd'))}`">
              <div
                class="is-flex tile-row"
                style="justify-content: space-between; align-items: center;"
              >
                <h1 class="tile-title">
                  Metas <br class="is-hidden-desktop" />
                  {{ displayedValue('metasd') | number1(1) }}%
                </h1>
                <div class="quadrant-indicators">
                  <sparkline
                    :values="seriesValues('metasd')"
                    :domain-min="sparklineDomain.min"
                    :domain-max="sparklineDomain.max"
                    :marker-index="sparklineMarkerIndex"
                    :width="56"
                    :height="20"
                  />
                  <variation-chip
                    :current="displayedValue('metasd')"
                    :previous="displayedPrevious('metasd')"
                    :label="comparisonLabel"
                  />
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>

      <div class="bottom-indicators-row">
        <div
          class="indicator-cell has-text-centered"
          :class="`rango${rangos(displayedValue('lidd'))}`"
        >
          <div
            class="is-flex"
            style="justify-content: space-between; align-items: center;"
          >
            <h2 class="tile-title">Liderazgo</h2>
            <div class="quadrant-indicators quadrant-indicators-sm">
              <sparkline
                :values="seriesValues('lidd')"
                :domain-min="sparklineDomain.min"
                :domain-max="sparklineDomain.max"
                :marker-index="sparklineMarkerIndex"
                :width="44"
                :height="16"
              />
              <variation-chip
                :current="displayedValue('lidd')"
                :previous="displayedPrevious('lidd')"
              />
            </div>
          </div>
        </div>
        <div
          class="indicator-cell has-text-centered"
          :class="`rango${rangos(displayedValue('recd'))}`"
        >
          <div
            class="is-flex"
            style="justify-content: space-between; align-items: center;"
          >
            <h2 class="tile-title">Recursos</h2>
            <div class="quadrant-indicators quadrant-indicators-sm">
              <sparkline
                :values="seriesValues('recd')"
                :domain-min="sparklineDomain.min"
                :domain-max="sparklineDomain.max"
                :marker-index="sparklineMarkerIndex"
                :width="44"
                :height="16"
              />
              <variation-chip
                :current="displayedValue('recd')"
                :previous="displayedPrevious('recd')"
              />
            </div>
          </div>
        </div>
        <div
          class="indicator-cell has-text-centered"
          :class="`rango${rangos(displayedValue('compd'))}`"
        >
          <div
            class="is-flex"
            style="justify-content: space-between; align-items: center;"
          >
            <h2 class="tile-title">Compensación</h2>
            <div class="quadrant-indicators quadrant-indicators-sm">
              <sparkline
                :values="seriesValues('compd')"
                :domain-min="sparklineDomain.min"
                :domain-max="sparklineDomain.max"
                :marker-index="sparklineMarkerIndex"
                :width="44"
                :height="16"
              />
              <variation-chip
                :current="displayedValue('compd')"
                :previous="displayedPrevious('compd')"
              />
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <evolution-chart :series="summary.series" />

    <evolution-summary-table :series="summary.series" :rangos="rangos" />
  </div>
</template>

<script>
import Sparkline from "../sparkline.vue";
import VariationChip from "../variationChip.vue";
import EvolutionChart from "../evolutionChart.vue";
import EvolutionSummaryTable from "../../evolutionSummaryTable.vue";

export default {
  name: "Evolution",

  components: {
    Sparkline,
    VariationChip,
    EvolutionChart,
    EvolutionSummaryTable,
  },

  props: {
    summary: {
      type: Object,
      required: true,
    },

    rangos: {
      type: Function,
      required: true,
    },

    nombrerangos: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedIndex: null,
    };
  },

  methods: {
    seriesValues(group) {
      if (!this.summary.series) return [];
      return this.summary.series.map((s) =>
        s.total && s.total[group] ? s.total[group].p : 0,
      );
    },

    dateLabel(pt) {
      if (!pt || !pt.fecha) return "";
      const date = new Date(pt.fecha);
      return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });
    },

    displayedValue(group) {
      const point = this.summary.series && this.summary.series[this.activeIndex];
      return point && point.total && point.total[group] ? point.total[group].p : 0;
    },

    displayedPrevious(group) {
      if (this.activeIndex <= 0) return null;
      const point = this.summary.series[this.activeIndex - 1];
      return point && point.total && point.total[group] ? point.total[group].p : null;
    },
  },

  computed: {
    activeIndex() {
      if (this.selectedIndex !== null) return this.selectedIndex;
      return this.summary.series ? this.summary.series.length - 1 : 0;
    },

    sparklineMarkerIndex() {
      const lastIndex = this.summary.series ? this.summary.series.length - 1 : 0;
      return this.activeIndex === lastIndex ? null : this.activeIndex;
    },

    comparisonLabel() {
      const previousPoint =
        this.summary.series && this.summary.series[this.activeIndex - 1];
      if (!previousPoint || !previousPoint.fecha) return "";
      return `vs ${new Date(previousPoint.fecha).getFullYear()}`;
    },

    sparklineDomain() {
      const groups = [
        "CClimad",
        "apoyod",
        "innovaciond",
        "calidadd",
        "metasd",
        "lidd",
        "recd",
        "compd",
        "engad",
      ];
      const all = groups.reduce(
        (acc, group) => acc.concat(this.seriesValues(group)),
        [],
      );
      if (!all.length) return { min: 0, max: 100 };
      const min = Math.min(...all);
      const max = Math.max(...all);
      const padding = Math.max((max - min) * 0.1, 1);
      return {
        min: Math.max(0, min - padding),
        max: Math.min(100, max + padding),
      };
    },
  },
};
</script>

<style scoped>
.tablero-preview {
  padding: 2.5rem 2rem;
}

.tablero-body {
  position: relative;
}

.tablero-preview-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 14px;
}

.tira {
  background: #f6f6f8;
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  margin-bottom: 20px;
}

.tira-chips {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.tira-label {
  font-size: 11px;
  font-weight: 600;
  color: #6b6b76;
  margin-right: 4px;
}

.tira-line {
  width: 14px;
  height: 1px;
  background: #d6d6de;
}

.tira-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d6d6de;
  border-radius: 20px;
  background: #fff;
  color: #6b6b76;
  font-size: 11px;
  padding: 5px 11px;
  white-space: nowrap;
  cursor: pointer;
}

.tira-chip.is-anchor {
  background: #510087;
  border-color: #510087;
  color: #fff;
  font-weight: 600;
}

.tira-chip-tag {
  color: #9a9aa5;
  font-size: 10px;
  font-weight: normal;
}

.tira-chip.is-anchor .tira-chip-tag {
  color: #ffffffb0;
}

.tira-hint {
  font-size: 11.5px;
  color: #7a7a7a;
  margin: 2px 0 0;
}

.tile-title {
  text-align: left;
  min-width: 0;
}

.tile-row {
  padding: 1.5rem;
}

.table-general {
  width: 80%;
  margin: 0 auto;
  table-layout: fixed;
}

.table-general td {
  padding: 0.5rem;
  min-width: 0;
}

.table-general td div {
  border-radius: 5px;
}

.bottom-indicators-row {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  width: 80%;
  margin: 0.5rem auto 0;
  padding: 0.5rem;
}

.bottom-indicators-row .indicator-cell {
  flex: 1;
  padding: 0.5rem 0.75rem;
  border-radius: 5px;
  min-width: 0;
}

.bottom-indicators-row .indicator-cell h2 {
  font-size: 1rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

.quadrant-indicators {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  min-width: 0;
  flex: 0 1 auto;
}

.quadrant-indicators-sm {
  gap: 6px;
}

.engagement-circle {
  position: absolute;
  top: 0;
  right: 0;
  width: 95px;
  height: 95px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-shadow: 0 2px 4px rgba(50, 50, 50, 0.4);
}

.engagement-circle-lg {
  width: 120px;
  height: 120px;
}

.engagement-circle .engagement-label {
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.engagement-circle .engagement-value {
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1;
  margin-top: 4px;
}

.engagement-circle .engagement-sparkline {
  margin-top: 2px;
}

.engagement-circle .engagement-variation-chip {
  margin-top: 2px;
  padding: 2px 6px;
  font-size: 0.68rem;
}

.clima-text-block {
  padding: 1.5rem;
  flex: 1;
  gap: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.clima-title-group {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
  text-align: left;
}

.clima-nombre-line {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 4px;
}

.clima-valor-line {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.clima-content-value {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 0;
  flex: 0 1 auto;
}

.clima-sparkline,
.clima-variation-chip {
  flex: none;
}

@media (max-width: 768px) {
  .table-general,
  .table-general tr,
  .table-general td {
    display: block;
    width: 100% !important;
  }

  .table-general h1 {
    font-size: 1rem !important;
  }

  .tile-row {
    padding: 0.75rem !important;
  }

  .tablero-preview {
    padding: 1.25rem 0.75rem;
  }

  .bottom-indicators-row {
    width: 100%;
    flex-direction: column;
    padding: 0.5rem;
  }

  .bottom-indicators-row .indicator-cell {
    flex: 1 1 100%;
    min-width: unset;
  }

  .engagement-circle {
    display: none;
  }

  .clima-text-block {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    padding: 0.75rem;
  }

  .clima-nombre-line {
    font-size: 0.85rem;
    font-weight: 400;
  }

  .clima-valor-line {
    font-size: 1.4rem;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/tabs/Evolution.vue